import { render } from "./ContactSimp.vue?vue&type=template&id=70499f79"
import script from "./ContactSimp.vue?vue&type=script&lang=js"
export * from "./ContactSimp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__